module.exports = require("@wildboar/x500/src/lib/modules/DSAOperationalAttributeTypes/dseType.oa");